import { extend } from 'vee-validate';
import { required, min_value, required_if } from 'vee-validate/dist/rules';

extend('required', required);
extend('required_if', required_if);
extend('min_value', min_value);
